import React from "react";
import IAction from "models/IAction";
import IStore from "models/IStore";
import { connect, DispatchProp } from "react-redux";
import BaseTable from "views/components/base-table/BaseTable";
import IconNameEnum from "constants/IconNameEnum";
import BaseIcon from "views/components/base-form/BaseIcon";
import CercaPreventivoDettaglio from "./CercaPreventivoDettaglio";
import CercaPreventiviTabellaModel from "stores/ricerca/models/CercaPreventiviTabellaModel";
import NotePopup from "views/components/note/NotePopup";
import CercaPreventiviModel from "stores/ricerca/models/CercaPreventiviModel";
import CercaPreventiviFormModel from "stores/ricerca/models/CercaPreventiviFormModel";
import moment from "moment";
import CercaAction from "stores/ricerca/CercaAction";
import { ISearchPreventiviRequest } from "stores/ricerca/CercaEffects";
import FormatUtility from "utilities/FormatUtility";
import LoadingIndicator from "views/components/loading-indicator/LoadingIndicator";
import { selectRequesting } from "selectors/requesting/RequestingSelector";
import { Row, Col } from "react-bootstrap";
import { BasePaginationReact } from "views/components/base-table/BasePaginationReact";
import SimulazioneStepOneFormModel from "stores/simulazione/models/SimulazioneStepOneFormModel";
import SimulazioneStepTwoFormModel from "stores/simulazione/models/SimulazioneStepTwoFormModel";
import CercaDettalgioSimulazioneModel from "stores/ricerca/models/CercaDettalgioSimulazioneModel";
import DateFormatEnum from "constants/DateFormatEnum";
import SimulazioneModel from "stores/simulazione/models/SimulazioneModel";
import SimulazioneAction from "stores/simulazione/SimulazioneAction";
import LookUpAction from "stores/lookup/LookUpAction";
import NavigationUtility from "utilities/NavigationUtility";
import RouteEnum from "constants/RouteEnum";
import CercaDettalgioPreventivoModel from "stores/ricerca/models/CercaDettalgioPreventivoModel";
import SimulazioneStepThreeFormModel from "stores/simulazione/models/SimulazioneStepThreeFormModel";
import { ISimulateRequest } from "stores/simulazione/SimulazioneEffect";
import NotaAction from "stores/note/NotaAction";
import { IGetNoteTopicsRequest } from "stores/note/NotaEffect";
import environment from "environment";
import StepsUtility from "utilities/StepsUtility";
import EstimateAction from "stores/estimate/EstimateAction";
import CanaliModel from "../../stores/lookup/models/CanaliModel";

interface IProps {
    readonly onExportSimulazione: () => void;
}

interface IState {
    readonly openDettaglioPopup: boolean;
    readonly openNotePopup: boolean;
    readonly isNavigating: boolean;
}

interface IStateToProps {
    readonly cercaPreventiviResponse: CercaPreventiviModel;
    readonly formModel: CercaPreventiviFormModel;
    readonly isRequesting: boolean;
    readonly formStep1: SimulazioneStepOneFormModel;
    readonly dettaglioSimulazione?: CercaDettalgioSimulazioneModel;
    readonly formValuesStep2: SimulazioneStepTwoFormModel;
    readonly dettaglioPreventivo?: CercaDettalgioPreventivoModel;
    readonly resumedSimulazione: SimulazioneModel;
    readonly canali: CanaliModel[];
}

const mapStateToProps = (state: IStore): IStateToProps => ({
    cercaPreventiviResponse: state.cerca.cercaPreventiviResponse,
    formModel: state.cerca.cercaPreventiviForm,
    isRequesting: selectRequesting(state, [CercaAction.REQUEST_CERCA_PREVENTIVI]),
    formStep1: state.simulazione.formStep1,
    dettaglioSimulazione: state.cerca.cercaDettalgioSimulazioneModel,
    formValuesStep2: state.simulazione.formStep2,
    dettaglioPreventivo: state.cerca.dettalgioPreventivoModel,
    resumedSimulazione: state.simulazione.resumedSimulazione,
    canali: state.lookup.canali,
});

class CercaPreventiviTabella extends React.Component<IProps & IStateToProps & DispatchProp<IAction<any>>, IState> {
    constructor(props: IProps & IStateToProps & DispatchProp<IAction<any>>) {
        super(props);
        this.state = {
            openDettaglioPopup: false,
            openNotePopup: false,
            isNavigating: false,
        };
    }
    private hasUnmounted = false;

    public componentWillUnmount() {
        this.hasUnmounted = true;
    }

    private headers = [
        "N° preventivo",
        "N° pratica",
        "Nome",
        "Cognome",
        "Tipo richiesta",
        "Tipologia Cliente",
        "Agente",
        "Rata",
        "Durata",
        "Montante",
        "Provvigioni",
        "Saldo",
        "Dettaglio",
        "Note",
    ];

    private getRow = (tabella: CercaPreventiviTabellaModel, i: number): JSX.Element[] => [
        <div
            onClick={() => this.handleRedirectStep3(tabella)}
            className="cursor-pointer text-ocq-blue font-weight-bold"
        >
            {tabella?.idEstimateRequest!}
        </div>,
        <>{tabella.idPractice ?? "-"}</>,
        <>{tabella.firstName ?? "-"}</>,
        <>{tabella.lastName ?? "-"}</>,
        <>{tabella.requestType ?? "-"}</>,
        <>{tabella.customerType ?? "-"}</>,
        <>{tabella.agent ?? "-"}</>,
        <>{FormatUtility.currency(tabella.installment ?? "-")}</>, //check with Krsitan
        <>{tabella.duration ?? "-"} mesi</>,
        <>{FormatUtility.currency(tabella.futureValue ?? "-")}</>,
        <>{FormatUtility.currency(tabella.commissions ?? "-")}</>,
        <>{FormatUtility.currency(tabella.balance ?? "-")}</>,
        <>
            <BaseIcon icon={IconNameEnum.Documento} className="cqs-icon" onClick={() => this.handleClick(tabella)} />
        </>,
        <>
            <BaseIcon
                icon={IconNameEnum.Messaggio}
                className="cqs-icon"
                onClick={() => this.handleOpenPopup(tabella)}
                badge={tabella.unreadNotes > 0 ? tabella.unreadNotes : ""}
            />
        </>,
    ];

    private handleClick = (data?: CercaPreventiviTabellaModel) => {
        this.setState({
            openDettaglioPopup: !this.state.openDettaglioPopup,
        });

        this.getDettaglioPreventivo(data!);
    };

    private getDettaglioPreventivo = async (item: CercaPreventiviTabellaModel) => {
        await this.props.dispatch(CercaAction.GetDettagliPreventivi(item));
    };

    private handleOpenPopup = async (data: CercaPreventiviTabellaModel) => {
        await this.addLoader();
        await this.props.dispatch(
            CercaAction.dettaglioPreventivoGet(Number(data.idEstimate!), Number(data.idEstimateRequest!))
        );

        await this.props.dispatch(NotaAction.getEstimateNote(Number(data?.idEstimate)));

        console.log(data.unreadNotes);

        data.unreadNotes > 0 && (await this.handleNoteAsRead(Number(data.idEstimate!)));

        await this.props.dispatch(NotaAction.getEstimateNote(Number(data?.idEstimate)));
        //await this.handleSearchEstimate();
        await this.removeLoader();

        await this.handleCloseNotePopup();
    };

    private handleSearchEstimate = async () => {
        let data = new CercaPreventiviFormModel({ ...this.props.formModel });

        let dataCreazioneDa = data.dataCreazioneDa
            ? moment.utc(data.dataCreazioneDa, "DD/MM/YYYY").toISOString()
            : undefined;
        let dataCreazioneA = data.dataCreazioneA ? moment.utc(data.dataCreazioneA, "DD/MM/YYYY") : undefined;
        if (dataCreazioneA) {
            const today = new Date();
            dataCreazioneA.set({
                hour: today.getHours(),
                minute: today.getMinutes(),
                second: today.getSeconds(),
            });
        }

        const requestEstimate: ISearchPreventiviRequest = {
            pageNumber: 0,
            pageSize: 20,
            sortParam: this.props.formModel.colName!,
            sortAsc: this.props.formModel.direction === "A" ? true : false,
            idEstimate: data.numPreventivo ? data.numPreventivo : undefined,
            idPractice: data.numPratica ? data.numPreventivo : undefined,
            creationDateFrom: dataCreazioneDa ? dataCreazioneDa : undefined,
            creationDateTo: dataCreazioneA ? dataCreazioneA.toISOString() : undefined,
            simulationName: data.denominazione ? data.denominazione : undefined,
            idSimulation: data.numSimulazione ? data.numSimulazione : undefined,
            idAgent: data.agente ? Number(data.agente) : undefined,
            idChannel: data.canale ? Number(data.canale) : undefined,
            idSegment: data.segmento ? Number(data.segmento) : undefined,
            idProduct: data.tipoProdotto ? Number(data.tipoProdotto) : undefined,
            requestType: data?.tipoRichiesta! ? Number(data?.tipoRichiesta!) : undefined,
            idAdministrativeCategory: data.tipoCliente ? Number(data.tipoCliente) : undefined,
            installment: data.rata ? Number(data.rata) : undefined,
            duration: data.durata ? Number(data.durata) : undefined,
            amount: data.importo ? Number(data.importo) : undefined,
            firstName: data.firstName ? data.firstName : undefined,
            lastName: data.lastName ? data.lastName : undefined,
        };
        if (this.hasUnmounted === false) {
            await this.props.dispatch(CercaAction.searchEstimates(requestEstimate));
        }
    };

    private handleNoteAsRead = async (id: number) => {
        await this.props.dispatch(NotaAction.setNoteAsRead(id));
    };

    private handleCloseNotePopup = async () => {
        await this.addLoader();
        const request: IGetNoteTopicsRequest = {
            pageNumber: 0,
            pageSize: 100,
        };

        await this.props.dispatch(NotaAction.getNoteTopics(request));

        this.setState({ openNotePopup: !this.state.openNotePopup });
        await this.removeLoader();
    };

    private handlePageChange = async (page?: { selected: number }) => {
        let data = new CercaPreventiviFormModel({ ...this.props.formModel });

        let dataCreazioneDa = data.dataCreazioneDa
            ? moment.utc(data.dataCreazioneDa, "DD/MM/YYYY").toISOString()
            : undefined;
        let dataCreazioneA = data.dataCreazioneA ? moment.utc(data.dataCreazioneA, "DD/MM/YYYY") : undefined;
        if (dataCreazioneA) {
            const today = new Date();
            dataCreazioneA.set({
                hour: today.getHours(),
                minute: today.getMinutes(),
                second: today.getSeconds(),
            });
        }

        const request: ISearchPreventiviRequest = {
            pageNumber: page!.selected + 1,
            pageSize: 20,
            sortParam: this.props.formModel.colName!,
            sortAsc: this.props.formModel.direction === "A" ? true : false,
            idEstimate: data.numPreventivo ? data.numPreventivo : undefined,
            idPractice: data.numPratica ? data.numPreventivo : undefined,
            creationDateFrom: dataCreazioneDa ? dataCreazioneDa : undefined,
            creationDateTo: dataCreazioneA ? dataCreazioneA.toISOString() : undefined,
            simulationName: data.denominazione ? data.denominazione : undefined,
            idSimulation: data.numSimulazione ? data.numSimulazione : undefined,
            idAgent: data.agente ? Number(data.agente) : undefined,
            idChannel: data.canale ? Number(data.canale) : undefined,
            idSegment: data.segmento ? Number(data.segmento) : undefined,
            idProduct: data.tipoProdotto ? Number(data.tipoProdotto) : undefined,
            requestType: data?.tipoRichiesta! ? Number(data?.tipoRichiesta!) : undefined,
            idAdministrativeCategory: data.tipoCliente ? Number(data.tipoCliente) : undefined,
            installment: data.rata ? Number(data.rata) : undefined,
            duration: data.durata ? Number(data.durata) : undefined,
            amount: data.importo ? Number(data.importo) : undefined,
            firstName: data.firstName ? data.firstName : undefined,
            lastName: data.lastName ? data.lastName : undefined,
        };
        if (this.hasUnmounted === false) {
            await this.props.dispatch(CercaAction.searchEstimates(request));
        }
    };

    private handleTableSort = async (name?: keyof CercaPreventiviTabellaModel, direction?: undefined | "A" | "D") => {
        let data = new CercaPreventiviFormModel({ ...this.props.formModel });
        let formValues = new CercaPreventiviFormModel(this.props.formModel);

        formValues = FormatUtility.updateNestedPropertyValue<CercaPreventiviFormModel>(formValues, "colName", name!);

        formValues = FormatUtility.updateNestedPropertyValue<CercaPreventiviFormModel>(
            formValues,
            "direction",
            direction!
        );

        let dataCreazioneDa = data.dataCreazioneDa
            ? moment.utc(data.dataCreazioneDa, "DD/MM/YYYY").toISOString()
            : undefined;
        let dataCreazioneA = data.dataCreazioneA ? moment.utc(data.dataCreazioneA, "DD/MM/YYYY") : undefined;
        if (dataCreazioneA) {
            const today = new Date();
            dataCreazioneA.set({
                hour: today.getHours(),
                minute: today.getMinutes(),
                second: today.getSeconds(),
            });
        }

        const request: ISearchPreventiviRequest = {
            pageNumber: this.props.cercaPreventiviResponse.pageNumber,
            pageSize: 20,
            sortParam: name!,
            sortAsc: direction === "A" ? true : false,
            idEstimate: data.numPreventivo ? data.numPreventivo : undefined,
            idPractice: data.numPratica ? data.numPreventivo : undefined,
            creationDateFrom: dataCreazioneDa ? dataCreazioneDa : undefined,
            creationDateTo: dataCreazioneA ? dataCreazioneA.toISOString() : undefined,
            simulationName: data.denominazione ? data.denominazione : undefined,
            idSimulation: data.numSimulazione ? data.numSimulazione : undefined,
            idAgent: data.agente ? Number(data.agente) : undefined,
            idChannel: data.canale ? Number(data.canale) : undefined,
            idSegment: data.segmento ? Number(data.segmento) : undefined,
            idProduct: data.tipoProdotto ? Number(data.tipoProdotto) : undefined,
            requestType: data?.tipoRichiesta! ? Number(data?.tipoRichiesta!) : undefined,
            idAdministrativeCategory: data.tipoCliente ? Number(data.tipoCliente) : undefined,
            installment: data.rata ? Number(data.rata) : undefined,
            duration: data.durata ? Number(data.durata) : undefined,
            amount: data.importo ? Number(data.importo) : undefined,
            firstName: data.firstName ? data.firstName : undefined,
            lastName: data.lastName ? data.lastName : undefined,
        };
        if (this.hasUnmounted === false) {
            await this.props.dispatch(CercaAction.setCercaPreventivoForm(formValues));
            await this.props.dispatch(CercaAction.searchEstimates(request));
        }
    };

    private handleClosePopup = () => {
        this.setState({
            openDettaglioPopup: !this.state.openDettaglioPopup,
        });
    };

    private addLoader = async () => {
        this.setState({ isNavigating: true });
    };

    private removeLoader = async () => {
        this.setState({ isNavigating: false });
    };

    private handleRedirectStep3 = async (data: CercaPreventiviTabellaModel) => {
        debugger;

        await this.addLoader();

        // let idSimulation = Number(data.idSimulation!);
        // if (data.idSimulation == null) {
        //     idSimulation = Number(dettaglioPreventivo?.idSimulation!);
        // }
        //await this.props.dispatch(CercaAction.dettaglioSimulazioniGet(idSimulation));

        await this.props.dispatch(CercaAction.resetDettaglioPreventivo());
        await this.props.dispatch(
            CercaAction.dettaglioPreventivoGet(Number(data.idEstimate!), Number(data.idEstimateRequest!))
        );

        let idSimulation = await this.getIdSimulazione(data);
        await this.dettaglioSimulazioni(idSimulation);
        await this.getResumedSimulazione(idSimulation);
        await this.handlePreventivoRedirect();
    };

    private handlePreventivoRedirect = async () => {
        debugger;
        const { formValuesStep2, canali, dettaglioSimulazione, dettaglioPreventivo, resumedSimulazione } = this.props;
        debugger;
        if (dettaglioSimulazione?.idAgent) {
            this.props.dispatch(LookUpAction.canaliGet(Number(dettaglioSimulazione?.idAgent)));
        }
        if (dettaglioSimulazione && dettaglioPreventivo && resumedSimulazione) {
            const step1FormValues = StepsUtility.setStep1FormValues(
                dettaglioSimulazione,
                resumedSimulazione,
                canali,
                dettaglioPreventivo
            );
            // const step1FormValues = new SimulazioneStepOneFormModel({
            //     cliente: dettaglioSimulazione.idAdministrativeCategory.toString(),
            //     idAdministration: dettaglioSimulazione.idAdministration,
            //     amministrazioneCensita: dettaglioSimulazione.idAdministration != null,
            //     amministrazioneNonCensita: dettaglioSimulazione.idAdministration == null,
            //     atc: dettaglioSimulazione.idAdministration
            //         ? dettaglioSimulazione.atc
            //         : dettaglioSimulazione.unregisteredAtcName,
            //     dataNascita: moment(dettaglioSimulazione.birthDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
            //         DateFormatEnum.ITA_DATE
            //     ),
            //     nettoMensile:
            //         dettaglioSimulazione.requestType === "CQS" || dettaglioSimulazione.requestType === "DLG"
            //             ? FormatUtility.numberWithSeparators(dettaglioSimulazione.salary.toString(), 0.01)?.toString()
            //             : undefined,
            //     pensioneNettaMensile:
            //         dettaglioSimulazione.requestType === "CQP"
            //             ? FormatUtility.numberWithSeparators(dettaglioSimulazione.salary.toString(), 0.01)?.toString()
            //             : undefined,
            //     dataAssunzione:
            //         dettaglioSimulazione.requestType === "CQS" || dettaglioSimulazione.requestType === "DLG"
            //             ? moment(dettaglioSimulazione.hiringDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
            //                   DateFormatEnum.ITA_DATE
            //               )
            //             : undefined,
            //     dataDecorrenza: moment(dettaglioSimulazione.effectiveDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
            //         DateFormatEnum.ITA_DATE
            //     ), //effective
            //     dataPensionamento:
            //         dettaglioSimulazione.requestType === "CQP"
            //             ? moment(dettaglioSimulazione.hiringDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
            //                   DateFormatEnum.ITA_DATE
            //               )
            //             : undefined,
            //     boxOneRata: FormatUtility.numberWithSeparators(
            //         dettaglioSimulazione.payment.toString(),
            //         0.01
            //     )?.toString(),
            //     boxOneDurata: dettaglioSimulazione.duration,
            //     canale: dettaglioSimulazione.idChannel.toString(),
            //     segmento: dettaglioSimulazione.idSegment.toString(),
            //     fonte: dettaglioPreventivo.sourceType.toString(),
            //     dettaglioFonte: dettaglioPreventivo.sourceDetail,
            //     agente: dettaglioSimulazione.idAgent.toString(),
            //     tipologiaPratica: resumedSimulazione.idPracticeType
            //         ? resumedSimulazione.idPracticeType?.toString()
            //         : environment.defaultIdPracticeType,
            // });

            const step2FormValues = new SimulazioneStepTwoFormModel({
                ...formValuesStep2,
                nome: dettaglioSimulazione.name,
                convenzione: resumedSimulazione.idConvention.toString(),
                fasciaSottoLivelli: resumedSimulazione.idSubLevel
                    ? resumedSimulazione.idSubLevel?.toString()
                    : environment.defaultIdSubLevel,
            });

            const existingExtinctions = FormatUtility.numberWithSeparators(
                dettaglioPreventivo.existingExtinctions,
                0.01
            )?.toString();

            const step3FormValues = new SimulazioneStepThreeFormModel({
                name: dettaglioPreventivo.firstName,
                surname: dettaglioPreventivo.lastName,
                sex: dettaglioPreventivo.gender,
                birthNation: dettaglioPreventivo.birthNation,
                birthPlace: dettaglioPreventivo.birthPlaceCode,
                birthForeignPlace: dettaglioPreventivo.birthPlace,
                // birthCounty: dettaglioPreventivo.birthCounty,
                birthDate: dettaglioPreventivo.birthDate,
                taxCode: dettaglioPreventivo.fiscalCode.toUpperCase(),
                // residenceNation: dettaglioPreventivo.residenceNation,
                residenceNation: dettaglioPreventivo.residenceNation,
                residencePlace: dettaglioPreventivo.residencePlaceCode,
                residencePlaceAbroad: dettaglioPreventivo.residencePlaceAbroad,
                // residenceCounty: dettaglioPreventivo.residenceCounty,
                residenceAddress: dettaglioPreventivo.residenceAddress,
                residenceCivicNumber: dettaglioPreventivo.residenceCivicNumber,
                mobileNumber: dettaglioPreventivo.mobilePhone,
                email: dettaglioPreventivo.mail,
                existingExtinctions: existingExtinctions,
                thirdPartiesYearExtinctions: dettaglioPreventivo.thirdPartiesYearExtinctions === true ? "1" : "2",
                existingAssignment: dettaglioPreventivo.existingAssignment,
                residenceAddressType: dettaglioPreventivo.residenceAddressType,
                idEstimate: Number(dettaglioPreventivo.idEstimate),
                idAnag: dettaglioPreventivo.idAnag,
                typeId: dettaglioPreventivo.typeId,
            });

            const simulazione = new SimulazioneModel({
                idSimulation: dettaglioSimulazione.id,
                idProduct: dettaglioSimulazione.idProduct,
                idInsuranceRc: dettaglioSimulazione.insurances?.creditRisk?.idInsurance,
                idInsurancePriceListRc: dettaglioSimulazione.insurances?.creditRisk?.idInsurancePriceList,
                idInsuranceRv: dettaglioSimulazione.insurances?.lifeRisk?.idInsurance,
                idInsurancePriceListRv: dettaglioSimulazione.insurances?.lifeRisk?.idInsurancePriceList,
                agentCommissions: resumedSimulazione.agentCommissions,
                balance: resumedSimulazione.balance,
                idRequestType: dettaglioSimulazione.idRequestedType,
            });

            const simulateRequest: ISimulateRequest = {
                idProduct: dettaglioPreventivo.idProduct,
                idRequestedType: dettaglioPreventivo.idRequestType,
                idChannel: dettaglioPreventivo.idChannel,
                idSegment: dettaglioPreventivo.idSegment,
                idAgent: dettaglioPreventivo.idAgent,
                idAdministrativeCategory: dettaglioPreventivo.idAdministrativeCategory,
                instalment: dettaglioPreventivo.installment,
                duration: dettaglioPreventivo.duration,
                birthDate: dettaglioPreventivo.birthDate,
                hiringDate: dettaglioSimulazione.hiringDate,
                amount: resumedSimulazione.amount,
                simulationRequestType: resumedSimulazione.idRequestType,
                idConvention: resumedSimulazione.idConvention,
                idSubLevel: resumedSimulazione.idSubLevel,
                idPracticeType: resumedSimulazione.idPracticeType,
                effectiveDate: resumedSimulazione.effectiveDate,
            };

            await this.props.dispatch(SimulazioneAction.setFormStep1(step1FormValues));
            await this.props.dispatch(SimulazioneAction.setFormStep2(step2FormValues));
            await this.props.dispatch(SimulazioneAction.setFormStep3(step3FormValues));
            await this.props.dispatch(SimulazioneAction.setSimulazioneSalvata(resumedSimulazione));
            // await this.props.dispatch(SimulazioneAction.simulate(simulateRequest));

            await this.props.dispatch(
                LookUpAction.segmentiGet(
                    Number(dettaglioSimulazione.idRequestedType),
                    Number(dettaglioSimulazione.idAdministrativeCategory),
                    Number(dettaglioSimulazione.idChannel),
                    Number(dettaglioSimulazione.idAgent)
                )
            );

            await this.props.dispatch(
                SimulazioneAction.prodottiLightGet(
                    Number(dettaglioSimulazione.idRequestedType),
                    Number(dettaglioSimulazione.idAdministrativeCategory),
                    dettaglioSimulazione.idSegment.toString()!,
                    Number(dettaglioSimulazione.idAgent)
                )
            ); //TODO: use correct idAggent value
            await this.props.dispatch(LookUpAction.comuniGetBirthPlace(""));
            await this.props.dispatch(LookUpAction.comuniGetResidencePlace(""));
            this.redirectToPage(dettaglioPreventivo.requestType!);
            await this.props.dispatch(SimulazioneAction.setStep(2));
            await this.removeLoader();
        }
    };

    private redirectToPage = async (requestType: string) => {
        switch (requestType) {
            case "CQP":
                NavigationUtility.redirectToPage(RouteEnum.CQP);
                break;
            case "CQS":
                NavigationUtility.redirectToPage(RouteEnum.CQS);
                break;
            case "DLG":
                NavigationUtility.redirectToPage(RouteEnum.DLG);
                break;
        }
    };

    private getResumedSimulazione = async (id: number) => {
        await this.props.dispatch(SimulazioneAction.resumeSimulation(id));
        await this.props.dispatch(EstimateAction.resetPreventivo());
    };
    private dettaglioSimulazioni = async (idSimulation: number) => {
        await this.props.dispatch(CercaAction.dettaglioSimulazioniGet(idSimulation));
        //await this.props.dispatch(CercaAction.resetDettaglioPreventivo());
    };
    private getIdSimulazione = async (data: CercaPreventiviTabellaModel) => {
        const { dettaglioPreventivo } = this.props;
        let idSimulation = Number(data.idSimulation!);
        if (data.idSimulation == null) {
            idSimulation = Number(dettaglioPreventivo?.idSimulation!);
        }
        return idSimulation;
    };

    public render(): JSX.Element {
        const { openDettaglioPopup, openNotePopup, isNavigating } = this.state;
        const { cercaPreventiviResponse, onExportSimulazione } = this.props;
        const activeIndex = this.props?.cercaPreventiviResponse?.data.findIndex(
            (item: CercaPreventiviTabellaModel) => item.isExpired === false
        );
        const activeRows = this.props?.cercaPreventiviResponse?.data.map(
            (item: CercaPreventiviTabellaModel, index: number) => {
                if (item.isExpired === false) {
                    return index;
                }
            }
        ) as number[];
        return (
            <>
                {this.props.isRequesting || isNavigating ? (
                    <LoadingIndicator className="mb-3" isActive={true} />
                ) : (
                    <>
                        {cercaPreventiviResponse.data.length > 0 ? (
                            <>
                                <Row className="align-cercaPreventiviResponse-center pb-3">
                                    <Col sm={12} md={6} className="text-left">
                                        <span>In grigio sono evidenziati i preventivi scaduti</span>
                                    </Col>
                                    <Col sm={12} md={6} className="text-right">
                                        <BaseIcon
                                            className="download-excel-icon"
                                            hoverTitle="Scarica Excel"
                                            icon={IconNameEnum.EsportaExcel}
                                            onClick={onExportSimulazione}
                                        />
                                    </Col>
                                </Row>
                                <BaseTable<CercaPreventiviTabellaModel>
                                    headers={this.headers}
                                    getRow={this.getRow}
                                    items={cercaPreventiviResponse.data || []}
                                    modelId={"sjsId"}
                                    hideTotal={true}
                                    classNameTh="cq-text-black cq-background-blue"
                                    activeIndex={activeIndex}
                                    activeRows={activeRows} //Active items on the table. Remove if only 1 item needs to be active
                                    pagination={false}
                                    shadow={true}
                                    showElementi={false}
                                    borderTabel={false}
                                    headersOrderable={[
                                        { name: "idEstimateRequest", orderable: true },
                                        { name: "idPractice", orderable: true },
                                        { name: "firstName", orderable: true },
                                        { name: "lastName", orderable: true },
                                        { name: "requestType", orderable: true },
                                        { name: "customerType", orderable: true },
                                        { name: "agent", orderable: true },
                                        { name: "installment", orderable: true },
                                        { name: "duration", orderable: true },
                                        { name: "futureValue", orderable: true },
                                        { name: "commissions", orderable: true },
                                        { name: "balance", orderable: true },
                                    ]}
                                    defaultOrdered={{
                                        colName: this.props.formModel?.colName!,
                                        direction: this.props.formModel.direction,
                                    }}
                                    handleTableSort={this.handleTableSort}
                                />
                            </>
                        ) : (
                            <>
                                {cercaPreventiviResponse.pageNumber > 0 ? (
                                    <span className="font-weight-bold text-center">Nessun risultato trovato!</span>
                                ) : (
                                    <span className="font-weight-bold text-center">
                                        Avvia la ricerca di uno o più preventivi
                                    </span>
                                )}
                            </>
                        )}
                    </>
                )}
                {cercaPreventiviResponse.data.length > 0 && (
                    <BasePaginationReact
                        pageCount={cercaPreventiviResponse.totalPages}
                        onPageChange={this.handlePageChange}
                    />
                )}

                {openDettaglioPopup && (
                    <CercaPreventivoDettaglio open={openDettaglioPopup} handlePopup={this.handleClosePopup} />
                )}

                {openNotePopup && (
                    <NotePopup
                        open={openNotePopup}
                        isRequesting={isNavigating || this.props.isRequesting}
                        onClose={this.handleCloseNotePopup}
                    />
                )}
            </>
        );
    }
}

export { CercaPreventiviTabella as Unconnected };
export default connect(mapStateToProps)(CercaPreventiviTabella);
